import {Button, Stack, Typography} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {TagChip} from 'presentation/components';

import {
	ACTIONS,
	FIRST_ACTION_TARGET_ID,
	STATUS_BADGE_META,
	TABLE_COLUMNS,
	TABLE_FOOTER_NOTE,
} from '../../constants';
import {MobileCard, MobileCardRow} from '../../styles';
import {RefundDocumentStatusEnum, RefundDocumentTableProps} from '../../types';

export function SendDocumentsCards({rows, onSendDocument, onOpenAttachment}: RefundDocumentTableProps) {
	return (
		<Stack gap={1}>
			{rows.map((row, index) => {
				const badge = STATUS_BADGE_META[row.status];
				const isUnsent = row.status === RefundDocumentStatusEnum.PENDENTE;
				const actionLabel = isUnsent ? ACTIONS.sendDocument : ACTIONS.replaceDocument;
				const isFirstRow = index === 0;

				return (
					<MobileCard key={row.id}>
						<MobileCardRow>
							<TagChip label={badge.label} color={badge.color} />
							{row.obrigatorio ? <Icon name="check-default" size={20} /> : null}
						</MobileCardRow>

						<Typography variant="subtitle2">{row.documento}</Typography>

						<MobileCardRow>
							<Typography variant="caption" color="text.secondary">
								{TABLE_COLUMNS.dataEnvio}
							</Typography>
							<Typography variant="body2">{row.dataEnvio ?? '-'}</Typography>
						</MobileCardRow>

						<MobileCardRow>
							<Typography variant="caption" color="text.secondary">
								{TABLE_COLUMNS.anexo}
							</Typography>
							{row.anexo ? (
								<Button
									type="button"
									variant="text"
									size="small"
									onClick={() => onOpenAttachment(row)}
									endIcon={<Icon name="external-link-default" size={16} />}>
									{ACTIONS.viewDocument}
								</Button>
							) : (
								<Typography variant="body2">-</Typography>
							)}
						</MobileCardRow>

						<Button
							id={isFirstRow ? FIRST_ACTION_TARGET_ID : undefined}
							type="button"
							variant="outlined"
							size="small"
							sx={{borderRadius: 9999, alignSelf: 'flex-start'}}
							onClick={() => onSendDocument(row)}>
							{actionLabel}
						</Button>
					</MobileCard>
				);
			})}
			<Typography variant="caption" color="text.secondary" sx={{px: 1}}>
				{TABLE_FOOTER_NOTE}
			</Typography>
		</Stack>
	);
}
